<nav aria-labelledby="left-nav-heading">
  <div class="pagenav">
    @if (loadedSubFooters) {
      <div>
        @for (i of loadedSubFooters ; track i) {
          <ul>
            <li>
              <a id="security-nav-{{i.subFeatureCode}}" routerLink="/{{i.sfTraget}}/{{planId}}"  routerLinkActive="active">
                <div class="row">
                  @if (i.sfLevel === 2) {
                    <div  class="col-md-2"></div>
                  }
                  <div  class="col-md-10">{{i.subFeatureLabel}}</div></div></a>
                </li>
              </ul>
            }
          </div>
        }
        <!--
        <router-outlet></router-outlet>
        -->
      </div>
    </nav>
